/** The slippage a quote/price request was sent with; echoed onto the parsed response. */
type SentSlippageFields = {
  appliedSlippageBps?: number;
  appliedSlippageMode?: 'auto' | 'manual';
};

/**
 * Echoes the `slippageBps` actually present on the request URL onto the parsed
 * response, so display and submit-time analytics record exactly what was sent
 * instead of re-resolving live state (which can drift between quote and submit).
 * No-op when the request carried no client value (server/relayer default), and a
 * server-applied value on the response (Model B) always wins over the echo.
 */
export const withSentSlippage = <T extends object>(data: T, url: string, isAuto: boolean): T => {
  const sentBps = new URLSearchParams(url.split('?')[1]).get('slippageBps');
  if (sentBps === null) return data;
  const server = data as SentSlippageFields;
  return {
    ...data,
    appliedSlippageBps: server.appliedSlippageBps ?? Number(sentBps),
    appliedSlippageMode: server.appliedSlippageMode ?? (isAuto ? 'auto' : 'manual'),
  };
};
